<template>
  <div>
    <div v-if="VO_DETAILS" class="border p-2 mb-3 mt-2 baseContentFont mx-1">
      <b-row class="px-1">
        <b-col><b>Name: </b>{{ vooData.name }}</b-col>
        <b-col><b>Current Address: </b>{{ vooData.currentAddress }}</b-col>
        <b-col><b>County: </b>{{ vooData.county }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col md="4"><b>SSN: </b>{{ vooData.ssn }}</b-col>
        <b-col md="4"><b>DOB: </b>{{ vooData.dob }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Phone: </b>{{ vooData.phone }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Email: </b>{{ vooData.email }}</b-col>
      </b-row>
      <b-row class="mt-2 mb-1"><b-col><b>SSN</b></b-col></b-row>
      <div v-if="validateSSNDetails(vooData)" class="border mx-0 py-1">
        <b-row class="mx-0">
         <b-col class="pl-2"><b>SSN: </b>{{ vooData.ssn }}</b-col>
         <b-col><b>Valid: </b>{{ vooData.valid }}</b-col>
         <b-col><b>Issuance Date: </b>{{ vooData.issuanceDate }}</b-col>
        </b-row>
        <b-row class="mx-0">
         <b-col><b>Issued Location: </b>{{ vooData.issuedLocation }}</b-col>
        </b-row>
      </div>
      <NoRecordFound v-else></NoRecordFound>
      <b-row class="mt-2 mb-1"><b-col><b>Subject Property Summary</b></b-col></b-row>
      <b-row v-if="validateSubPropertyDetails(vooData)" class="border mx-0 py-1">
        <b-col class="pl-2"><b>Address: </b>{{ vooData.subAddress }}</b-col>
        <b-col><b>County: </b>{{ vooData.subCounty }}</b-col>
        <b-col><b>Property Type: </b>{{ vooData.subPropType }}</b-col>
      </b-row>
      <NoRecordFound v-else></NoRecordFound>
      <b-row>
        <b-col md="6">
          <b-row class="mt-3 text-center"><b-col><b>Verification of Occupancy Score</b></b-col></b-row>
          <b-row v-if="vooData.vooScore" class="mx-0 text-center">
            <b-col>
              <VueGauge
               :refid="`type-guage-${gaugeId}`"
               :options="guageOptions"
              />
              <!-- eslint-disable -->
              <div class="gaugeStyle" v-html="getOccupancyType(vooData.vooScore)"><span><b>{{ ' (' + vooData.vooScore + ')' }}</b></span></div>
              <!-- eslint-enable -->
            </b-col>
          </b-row>
          <b-row v-else class="text-center mt-5 pt-2 pb-4"><b-col><b>No data found</b></b-col></b-row>
        </b-col>
        <b-col md="6">
          <b-row class="mt-3 text-center"><b-col><b>Ownership Status and Property Type</b></b-col></b-row>
          <b-row v-if="vooData.ownerShipIndex"><b-col class="ml-5 pl-5 mt-5"><b-img width="500" :src="getPropertyImage(vooData.ownerShipIndex)"/></b-col></b-row>
          <b-row v-if="vooData.ownerStatus" class="mx-0 text-center mt-5 pb-4"><b-col>{{ vooData.ownerStatus }}</b-col></b-row>
          <b-row v-else class="text-center mt-5 pt-2 pb-4"><b-col><b>No data found</b></b-col></b-row>
        </b-col>
      </b-row>
      <b-row class="mt-1"><b-col><BaseELabel label="Verification of Occupancy Score Attributes" class="mb-2" new-style /></b-col></b-row>
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col>
              <b-table
                :items="vootabAItems"
                :fields="vooScoreAttributeFields1"
                hover
                bordered
                responsive
                striped
                class="mb-0 fraudReportHeaderTable">
              </b-table>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col>
              <b-table
                :items="vootabBItems"
                :fields="vooScoreAttributeFields2"
                hover
                bordered
                responsive
                striped
                class="mb-0 fraudReportHeaderTable">
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3"><b-col><BaseELabel label="Confirming Sources" class="mb-2" new-style /></b-col></b-row>
      <b-row>
        <b-col>
          <b-table
            :items="vooData.voOConfirmingSources"
            :fields="confirmingSourcesFields"
            hover
            bordered
            responsive
            striped
            class="mb-0 fraudReportHeaderTable">
          </b-table>
          <NoRecordFound v-if="!isListEmpty(vooData.voOConfirmingSources).length"></NoRecordFound>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
      <b-row class="mt-3 mb-1"><b-col><b>MERS - Target Property</b></b-col></b-row>
       <b-row v-if="vooData.occupancyStatus">
        <b-col>
          <b-row v-if="!mersStatusMessages.includes(vooData.occupancyStatus)" class="border mx-0 py-1">
            <b-col class="pl-2"><b>Occupancy Status: </b>{{ vooData.occupancyStatus }}</b-col>
          </b-row>
          <div v-else class="border baseContentFont py-1 text-center">{{ '*** ' + vooData.occupancyStatus + ' ***' }}</div>
        </b-col>
      </b-row>
      <NoRecordFound v-else></NoRecordFound>
    </b-col>
      </b-row>
      <b-row class="mt-3"><b-col><BaseELabel label="Other Real Estate Owned: Current" class="mb-2" new-style /></b-col></b-row>
      <b-row>
        <b-col>
          <b-table
            :items="vooData.voOOther"
            :fields="otherRealEstateFields"
            hover
            bordered
            responsive
            striped
            class="mb-0 fraudReportHeaderTable">
          </b-table>
          <NoRecordFound v-if="!isListEmpty(vooData.voOOther).length"></NoRecordFound>
        </b-col>
      </b-row>
      <b-row class="mt-3"><b-col><BaseELabel label="Associated Identities with Subject Property" class="mb-2" new-style /></b-col></b-row>
      <b-row>
        <b-col>
          <b-table
            :items="vooData.voOAssociates"
            :fields="associatedIdentitiesFields"
            hover
            bordered
            responsive
            striped
            class="mb-0 fraudReportHeaderTable">
          </b-table>
          <NoRecordFound v-if="!isListEmpty(vooData.voOAssociates).length"></NoRecordFound>
        </b-col>
      </b-row>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
import VueGauge from 'vue-gauge'
export default {
  components: {
    NoRecordFound,
    VueGauge,
  },
  props: {
    voDetails: {
      type: Object,
      default: () => {},
    },
    gaugeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      vooScoreAttributeFields1: [
        {
          key: 'label',
          label: '',
          thStyle: { width: '30%'},
          class: 'font-weight-bold textTruncatee',
        },
        {
          key: 'attribute',
          label: '',
          thStyle: { width: '70%' },
          class: 'textTruncatee',
        },
      ],
      vooScoreAttributeFields2: [
        {
          key: 'label',
          label: '',
          thStyle: { width: '30%' },
          class: 'font-weight-bold textTruncatee',
        },
        {
          key: 'attribute',
          label: '',
          thStyle: { width: '70%' },
          class: 'textTruncatee',
        },
      ],
      vooTableAKeys: ['confirmingSource','addressHistory','phoneHistory','propOwnershipStatus','associatedId'],
      vooTableBKeys: ['mailingAttribute','priorAddressAttribute','priorResident','occupancyOverride','otherProperty'],
      confirmingSourcesFields: [
        {
          key: 'sourceType',
          label: 'Source Type',
          thStyle: { width: '30%' },
        },
        {
          key: 'dfs',
          label: 'Date First Seen',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
        {
          key: 'dls',
          label: 'Date Last Seen',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
        {
          key: 'recordsCount',
          label: 'Number of Records',
          thStyle: { width: '30%' },
          class: 'text-right',
        },
      ],
      otherRealEstateFields: [
        {
          key: 'recordNumber',
          label: 'Record Number',
          thStyle: { width: '10%' },
          class: 'text-right',
        },
        {
          key: 'address',
          label: 'Address',
          thStyle: { width: '30%' },
        },
        {
          key: 'purchasedDate',
          label: 'Purchase Date',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
        {
          key: 'state',
          label: 'State',
          thStyle: { width: '20%' },
        },
        {
          key: 'proxtoSubject',
          label: 'Proximity To Subject Property',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
      ],
      vootabAItems: [],
      vootabBItems: [],
      guageOptions: {},
      vooTableALabels: [
        'Confirming Sources',
        'Address History',
        'Phone and Utility History',
        'Property Ownership Status',
        'Associated Identities',
      ],
      vooTableBLabels: [
        'Mailing Attributes',
        'Prior Address Attributes',
        'Prior Residents',
        'Occupancy Override',
        'Other Properties Owned - Proximity',
      ],
      associatedIdentitiesFields: [
        {
          key: 'associatedNames',
          label: 'Names',
          thStyle: { width: '30%' },
        },
        {
          key: 'associatedDFS',
          label: 'Date First Seen',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
        {
          key: 'associatedDLS',
          label: 'Date Last Seen',
          thStyle: { width: '20%' },
          class: 'text-right',
        },
        {
          key: 'relationship',
          label: 'Relationship to Applicant/Customer',
          thStyle: { width: '30%' },
        },
      ],
      vooData: null,
      // vooMersMsg: '*** Not Available ***',
      mersStatusMessages: ['Not Available', 'SSN Mismatch'],
    }
  },
  computed: {
    VO_DETAILS() {
      return this.voDetails || null
    },
  },
  created() {
    if(this.VO_DETAILS) {
      this.vooData = this.VO_DETAILS
    // loading default gauge options
    this.guageOptions = {
      needleColor: 'orange',
      needleValue: this.vooData.vooScore / 0.9,
      arcOverEffect: false,
      arcDelimiters: [10/0.9, 20/0.9, 30/0.9, 40/0.9, 50/0.9, 60/0.9, 70/0.9, 80/0.9],
      arcLabels: [10, 20, 30, 40, 50, 60, 70, 80],
      rangeLabel: ['0', '90'],
      arcColors: ['red', 'red', 'red', 'yellow', 'yellow', 'yellow', 'green', 'green', 'green'],
      chartWidth: 400,
    }
    // load table first cols data
    this.vootabAItems = this.vooTableALabels.map((x,i) => {
      return {
        label: x,
        attribute: this.vooData[this.vooTableAKeys[i]] || null ,
      }
    })
    this.vootabBItems = this.vooTableBLabels.map((x,i) => {
      return {
        label: x,
        attribute: this.vooData[this.vooTableBKeys[i]] || null ,
      }
    })
    }
  },
  methods: {
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
    validateSubPropertyDetails(obj) {
      if((obj.subAddress === "" || obj.subAddress === null) && (obj.subCounty === "" || obj.subCounty === null) && (obj.subPropType === "" || obj.subPropType === null)) {
        return false
      } else return true
    },
    validateSSNDetails(obj) {
      if((obj.ssn === "" || obj.ssn === null) && (obj.valid === "" || obj.valid === null) && (obj.issuanceDate === "" || obj.issuanceDate === null) && (obj.issuedLocation === "" || obj.issuedLocation === null)) {
        return false
      } else return true
    },
    getOccupancyType(score) {
      if(score) {
        if(score>=0 && score<=30) {
          return `Occupancy Risk - High <b>(${score.bold()})</b>`
        } else if(score>=30 && score<=60) {
          return `Occupancy Risk - Medium <b>(${score.bold()})</b>`
        } else if(score>=60 && score<=90) {
          return `Occupancy Risk - Low <b>(${score.bold()})</b>`
        }
      }
    },
    getPropertyImage(value) {
      return (value && value !== '-1') ? require(`@assets/images/propStatus${value}.png`) : null
    },
  },

}
</script>

<style scoped>
.gaugeStyle {
  position: absolute;
  z-index: 9999;
  margin-top: -40px;
  margin-left: 230px;
  font: 0.8125rem;
}
</style>
